export default __webpack_public_path__ + "static/media/external-link.f04c4f16.svg";